import { Routes } from '@angular/router';
import { RenderInterfaceGuard } from 'viggo-sistemas-core-web';

export const routesAdminAgendamento: Routes = [
  {
    path: 'agendamentos',
    canActivate: [RenderInterfaceGuard],
    data: {
      preload: false,
      module: 'AGENDAMENTOS',
      menuKey: 'AGENDAMENTOS',
      backend_path: '/agendamentos'
    },
    loadChildren: () =>
      import('@app/modules/agendamento/agendamento.module').then(
        m => m.AgendamentoModule
      )
  }
];
